import { HStack } from '@/components/ui/hstack'
import { Pressable } from '@/components/ui/pressable'
import { Text } from '@/components/ui/text'
import { VStack } from '@/components/ui/vstack'
import usePlatformColor from '@/lib/hooks/usePlatformColor'
import { markNotificationReadThunk, NotificationType } from '@/redux/slices/notificationSlice'
import { useAppDispatch } from '@/redux/store'
import dayjs from 'dayjs'
import { View } from 'react-native'

type ItemWrapperProps = {
  notification: NotificationType
  children: React.ReactNode
  onPress?: () => void
}

export default function ItemWrapper({ notification, children, onPress }: ItemWrapperProps) {
  const dispatch = useAppDispatch()

  const [textColor, secondaryTextColor] = usePlatformColor('label', 'secondaryLabel')

  const handlePress = () => {
    if (!notification.read) {
      dispatch(markNotificationReadThunk({ notificationId: notification.id }))
    }

    onPress?.()
  }

  return (
    <Pressable className="data-[active=true]:bg-background-100 px-4" onPress={handlePress}>
      <HStack className="py-4 items-center">
        <View style={{ width: '90%' }}>
          <VStack space="sm">
            <Text style={{ color: textColor }}>
              {children}
            </Text>
            <Text style={{ color: secondaryTextColor }}>
              {dayjs(notification.endTime).format('YYYY-MM-DD HH:mm:ss')}
            </Text>
          </VStack>
        </View>
        <View style={{ width: '10%' }} className="items-end">
          {!notification.read && <UnreadDot />}
        </View>
      </HStack>
    </Pressable>
  )
}

function UnreadDot() {
  return <View className="w-2 h-2 rounded-full bg-red-500" />
}
